import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, CardBody, Col, Input, Row } from 'reactstrap';
import { getSayimDetails } from '../../../services/sayim/sayim-api';

const SayimNoGiris = ({ onCountSelect, loading, setLoading }) => {
    const [countCode, setCountCode] = useState('');
    const [error, setError] = useState('');

    // Sayım durumları
    const statuData = [
        { id: "CREATED", text: "Sayım Girişi Yapıldı" },
        { id: "STARTED", text: "Sayım Başlatıldı" },
        { id: "COMPLETED", text: "Sayım Tamamlandı" },
        { id: "CANCELLED", text: "Sayım İptal Edildi" },
    ];

    // Sayım numarası girişi
    const handleCountInput = (e) => {
        const value = e.target.value.toUpperCase();
        setCountCode(value);
        // Hata mesajını temizle
        if (error) {
            setError('');
        }
    };

    // Sayım durumuna göre uyarı mesajı oluştur
    const getStatusMessage = (status) => {
        const statusItem = statuData.find(item => item.id === status);
        if (!statusItem) return 'Bilinmeyen durum';

        switch (status) {
            case 'CREATED':
                return 'Bu sayım henüz başlatılmamış. Lütfen önce sayımı başlatın.';
            case 'COMPLETED':
                return 'Bu sayım zaten tamamlanmış.';
            case 'CANCELLED':
                return 'Bu sayım iptal edilmiş.';
            case 'STARTED':
                return null; // Başarılı durum
            default:
                return 'Bu sayım durumu geçersiz.';
        }
    };

    // Sayım detaylarını API'den al
    const handleConfirm = async () => {
        if (!countCode.trim()) {
            setError('Lütfen sayım numarası giriniz.');
            return;
        }

        setLoading(true);
        setError('');

        try {
            // API'den sayım detaylarını al
            const sayimData = await getSayimDetails(countCode);

            // Sayım numarasının geçerli olup olmadığını kontrol et
            if (sayimData && sayimData.count_code && sayimData.success !== false) {
                // Sayım durumunu kontrol et
                if (sayimData.status === 'STARTED') {
                    // Geçerli sayım - ikinci ekrana geç
                    onCountSelect(sayimData);
                } else {
                    // Duruma göre uyarı mesajı göster
                    const statusMessage = getStatusMessage(sayimData.status);
                    setError(statusMessage);
                }
            } else {
                setError('Girilen koda ait sayım bulunamadı.');
            }
        } catch (error) {
            // 404 Not Found ve diğer hata durumları için güvenli hata yönetimi
            if (error?.response?.status === 404 || error?.status === 404) {
                setError('Girilen koda ait sayım bulunamadı.');
            } else if (error?.message?.includes('count details not found')) {
                setError('Girilen koda ait sayım bulunamadı.');
            } else if (error?.message?.includes('404')) {
                setError('Girilen koda ait sayım bulunamadı.');
            } else {
                console.error('Sayım detayları alınırken hata:', error);
                setError('Sayım bilgileri alınırken bir hata oluştu. Lütfen tekrar deneyiniz.');
            }
        } finally {
            setLoading(false);
        }
    };

    // Enter tuşu ile onaylama
    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && countCode.trim() && !loading) {
            handleConfirm();
        }
    };

    useEffect(() => {
        if (document.querySelector(".page-main-header")) document.querySelector(".page-main-header").classList.add('open');
        if (document.querySelector(".page-sidebar")) document.querySelector(".page-sidebar").classList.add('open');
    }, []);

    return (
        <>
            <div className="container-fluid">
                <Row className="justify-content-center">
                    <Col className='mt-2'>
                        <Card className="text-center">
                            <CardBody style={{ padding: '25px 15px' }}>
                                <strong>
                                    Sayım No Giriniz
                                </strong>

                                <Input
                                    type="text"
                                    value={countCode}
                                    placeholder="SAYIM000001"
                                    style={{
                                        margin: '10px 0',
                                        textAlign: 'center',
                                        fontWeight: '500',
                                        padding: '12px',
                                        fontSize: '1rem'
                                    }}
                                    onChange={handleCountInput}
                                    onKeyPress={handleKeyPress}
                                    autoFocus
                                    disabled={loading}
                                />

                                <Button
                                    color="success"
                                    style={{
                                        width: '100%',
                                        marginTop: '8px'
                                    }}
                                    onClick={handleConfirm}
                                    disabled={!countCode.trim() || loading}
                                >
                                    {loading ? <>Yükleniyor... </> : <><i className="fa fa-check"></i> ONAYLA</>}
                                </Button>

                                {/* Hata mesajı */}
                                {error && (
                                    <Alert
                                        color="danger"
                                        style={{
                                            marginTop: '10px',
                                            fontSize: '0.9rem',
                                            padding: '8px 12px'
                                        }}
                                    >
                                        {error}
                                    </Alert>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default SayimNoGiris;